import constants from "../../core/constants";
import map from "lodash/fp/map";
import isNil from "lodash/fp/isNil";
import moment from "moment";
import { parsePrice } from "../../core/utils";
class InvoicesPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { name: "captain", title: "Captain" },
      { name: "basic_plan", title: "Basic Plan" },
      { name: "backup_plan", title: "Backup Plan" },
      { name: "deduction_plan", title: "Supply Deduction Plan" },
      { name: "variable_plan", title: "Supply Variable Plan" },
      { name: "status", title: "Status" },
      { name: "paid", title: "Paid" },
      { name: "start_date", title: "Start Date" },
      { name: "end_date", title: "End Date" },
      { name: "total_amount", title: "Total Amount" },
      { name: "contractor", title: "Contractor" },
      { name: "company", title: "Company" },
    ];

    this.filters = [
      {
        name: "captain",
        title: "Captain",
        icon: "person",
        resource: "Captain",
        size: 25,
      },
      {
        name: "status",
        title: "Status",
        icon: "person",
        list: "invoiceStatus",
        multiple: true,
      },
      { name: "paid", title: "Is Paid", icon: "person", list: "invoicePaid" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.start_date = moment(item.start_date).format(constants.dateFormat);
      item.end_date = item.end_date
        ? moment(item.end_date).format(constants.dateFormat)
        : null;
      item.total_amount = parsePrice(item.total_amount);

      if (!isNil(item.contractor) && !isNil(item.contractor.name_i18n)) {
        item.contractor = item.contractor.name_i18n.en;
      }
      if (!isNil(item.company) && !isNil(item.company.name_i18n)) {
        item.company = item.company.name_i18n.en;
      }
      return item;
    };

    return map(format)(data);
  }
}

export default InvoicesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices.transforms.js